import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ICheckBoxGroupOption, ICheckBoxGroupOptionItem } from '../interfaces/checkbox-group-option';
import { IOptionItem } from '../interfaces/option-item.interface';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxGroupComponent implements OnInit {
  @Input() option: ICheckBoxGroupOption;
  @Input() countedItemsHeader: string;

  @ViewChild('container') container;

  selectedItemsCount: number = 0;

  isOpen: boolean;
  /**
   *
   */
  constructor() {}
  ngOnInit(): void {
   this.selectedItemsCount = this.getNumberOfCheckedGroupItems();
  }

  groupItemChanged(): void {
    this.option.groupHeaderItem.checked = !this.option.groupHeaderItem.checked;
    this.openContainerIfGroupItemCheckedElseClose();
    if(!this.option.groupHeaderItem.checked) {
      this.clearAll();
    }
  }
  
  groupItemToggled(value: boolean): void {
    this.option.groupHeaderItem.checked = value;
    this.openContainerIfGroupItemCheckedElseClose();
  }

  itemChanged(item: ICheckBoxGroupOptionItem): void {
    item.checked = !item.checked;
    this.selectedItemsCount = this.getNumberOfCheckedGroupItems();
    //Check the header checkbox if any of the children are checked.
    if (item.checked) {
      this.option.groupHeaderItem.checked = true;
    }
  }

  selectAll(): void {
    this.option.groupItems.forEach(item => item.checked = true);
    this.selectedItemsCount = this.option.groupItems.length;
    this.option.groupHeaderItem.checked = true;
  }

  clearAll(): void {
    this.option.groupItems.forEach(item => item.checked = false);
    this.selectedItemsCount = 0;
  }

  refocusContainer(): void {
    this.container.nativeElement.focus();
  }

  private openContainerIfGroupItemCheckedElseClose(): void {
    if (this.option.groupHeaderItem.checked) {
      this.isOpen = true;
    } else {
      this.isOpen = false;
    }
  }

  private getNumberOfCheckedGroupItems(): number {
    return this.option?.groupItems?.filter(x => x.checked)?.length || 0;
  }
}
